export const EP_REFERRAL = 'referral';